import { useEffect, useState } from 'react'
import { BannerModal } from 'Components/Modal/BannerModal'
import { type lookup } from 'core/types'
import { sendGet, sendPost } from 'hooks/use-fetch'
import { toast } from 'react-toastify'
import { SelectWithLabel } from 'Components/SelectWithLabel'

export interface SelectProgramModalProps {
  open: boolean
  onClose: () => void
  onConfirm: (selectedProgram: lookup) => void
  referralId: number
  isdServiceProviderId: number
}

export function SelectProgramModal (props: SelectProgramModalProps): JSX.Element {
  const [availablePrograms, setAvailablePrograms] = useState<lookup[]>([])
  const [selectedProgram, setSelectedProgram] = useState<lookup | null>(null)

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet(`/ReferralSearch/GetAvailablePrograms?isdServiceProviderID=${props.isdServiceProviderId}`, {})
      setAvailablePrograms(response)
    }
    void fetchData()
  }, [props.isdServiceProviderId])

  const handleChange = (e: any): void => {
    const program = availablePrograms.find(x => x.id.toString() === e.target.value) ?? null
    setSelectedProgram(program)
  }

  const handleSubmit = async (): Promise<void> => {
    if (selectedProgram === null) {
      toast.error('You must make a selection to continue')
      return
    }

    await sendPost('/ReferralEdit/SetProgram', {
      referralId: props.referralId,
      programID: selectedProgram.id
    })
    props.onConfirm(selectedProgram)
  }

  const content = <SelectWithLabel
    name='selectProgram'
    label='Program'
    width='100%'
    value={selectedProgram?.id}
    options={availablePrograms}
    onChange={handleChange}
  />

  return <BannerModal
    open={props.open}
    title='Select Program'
    onClose={props.onClose}
    onConfirm={handleSubmit}
    cancelButtonText='Cancel'
    confirmButtonText='Update'
    content={content}
    buttonClassName='modal-button'
  />
}
